//
//
//

export default {
    beforeRouteEnter(to, from, next) {
        next(() => {
            window.open('https://aanmeldloket.meidenvanholland.nl', '_blank', 'noopener,noreferrer');
        });
    },
    head() {
        return {
            link: [{
                rel: 'canonical',
                href: 'https://meidenvanholland.nl/info/aanmelden'
            }],
            meta: [
                { hid: 'robots', name: 'robots', content: 'noindex' },
                ]
        }
    },
}
